var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAverageTimeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "42px",
    viewBox: "0 0 46 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HSP-Dashboard-_dark-Copy",
    transform: "translate(-990.000000, -993.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kiosk-metrics",
    transform: "translate(84.000000, 880.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(899.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/checklist"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(8.091463, 3.991870)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BCBCBC",
    x: 12.8231707,
    y: 1.98373984,
    width: 31.3719512,
    height: 2.98780488
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#BCBCBC",
    strokeWidth: 1.5,
    points: "0 2.77628687 3.16561218 5.79115555 9.24632564 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(8.091463, 19.926829)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#BCBCBC",
    x: 12.8231707,
    y: 1.98373984,
    width: 31.3719512,
    height: 2.98780488
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy",
    stroke: "#BCBCBC",
    strokeWidth: 1.5,
    points: "0 2.77628687 3.16561218 5.79115555 9.24632564 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(8.091463, 35.861789)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#BCBCBC",
    x: 12.8231707,
    y: 1.98373984,
    width: 31.3719512,
    height: 2.98780488
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2-Copy-2",
    stroke: "#BCBCBC",
    strokeWidth: 1.5,
    points: "0 2.77628687 3.16561218 5.79115555 9.24632564 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "time",
    transform: "translate(26.524390, 13.897358)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 12.804878,
    cy: 18.1402439,
    r: 11.7378049
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0335366,27.5615854 C14.8872044,27.5615854 16.5902361,27.0981754 18.1426829,26.1713415 C19.6719589,25.2676784 20.8884101,24.0396419 21.7920732,22.4871951 C22.6957362,20.9347483 23.147561,19.2317166 23.147561,17.3780488 C23.147561,15.524381 22.6957362,13.8213492 21.7920732,12.2689024 C20.8884101,10.7396265 19.6719589,9.52317525 18.1426829,8.6195122 C16.5902361,7.71584914 14.8872044,7.26402439 13.0335366,7.26402439 C11.1798688,7.26402439 9.47683703,7.71584914 7.92439024,8.6195122 C6.3951143,9.52317525 5.17866305,10.7396265 4.275,12.2689024 C3.37133695,13.8213492 2.9195122,15.524381 2.9195122,17.3780488 C2.9195122,19.2317166 3.37133695,20.9347483 4.275,22.4871951 C5.17866305,24.0396419 6.3951143,25.2676784 7.92439024,26.1713415 C9.47683703,27.0981754 11.1798688,27.5615854 13.0335366,27.5615854 Z M23.2170732,9.31463415 C24.1207362,10.4500057 24.8158512,11.6896274 25.302439,13.0335366 C25.8121977,14.4237874 26.0670732,15.8719437 26.0670732,17.3780488 C26.0670732,19.7414752 25.4762254,21.9310875 24.2945122,23.9469512 C23.1359698,25.9164733 21.5719611,27.480482 19.602439,28.6390244 C17.5865753,29.8207376 15.396963,30.4115854 13.0335366,30.4115854 C10.6701101,30.4115854 8.48049788,29.8207376 6.46463415,28.6390244 C4.4951121,27.480482 2.93110335,25.9164733 1.77256098,23.9469512 C0.59084775,21.9310875 5.22248911e-13,19.7414752 5.22248911e-13,17.3780488 C5.22248911e-13,15.0146223 0.59084775,12.8250101 1.77256098,10.8091463 C2.93110335,8.8396243 4.4951121,7.27561555 6.46463415,6.11707317 C8.48049788,4.93535995 10.6701101,4.3445122 13.0335366,4.3445122 C14.5164708,4.3445122 15.9762123,4.61097295 17.4128049,5.14390244 C18.756714,5.65366109 20.007921,6.36036134 21.1664634,7.26402439 L23.2170732,5.14390244 C23.8658569,5.67683193 24.5493867,6.36036168 25.2676829,7.1945122 L23.2170732,9.31463415 Z M11.6085366,18.872561 L11.6085366,10.1835366 L14.4585366,10.1835366 L14.4585366,18.872561 L11.6085366,18.872561 Z M17.3780488,0 L17.3780488,2.9195122 L8.68902439,2.9195122 L8.68902439,0 L17.3780488,0 Z",
    id: "\\uEB4B",
    fill: "#BCBCBC",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageTimeIcon);
export default __webpack_public_path__ + "static/media/average_time_icon.f295f9b250049f685e865aa970f22f0a.svg";
export { ForwardRef as ReactComponent };